import React from "react"
import { Spin } from "antd"
import { Waypoint } from "react-waypoint"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import EmbeddedExperienceCard from "../../../../Embedded/ExperienceCard/index"
import { getExperienceMainPhoto } from "../../utils/getExperienceMainPhoto"
import { isLastPage } from "helpers/pagination"
import { formatExperienceTermsFull } from "utils/experience"
import styles from "./index.module.css"

const ExperienceGrid = ({ experiences, guuid, loading, hasMore, onLoadMore, metadata, scrollableAncestor }) => {
  const { t } = useTranslation()
  const lastPage = isLastPage(metadata)
  const shouldShowWaypoint = !lastPage && hasMore

  return (
    <>
      <div className={styles.gridContainer}>
        {experiences?.map((exp, index) => {
          const mainPhotoUrl = getExperienceMainPhoto(exp)

          return (
            <div key={exp?.uuid || index} className={styles.gridItem}>
              <EmbeddedExperienceCard
                image={mainPhotoUrl}
                title={exp?.title}
                location={exp?.address}
                time={formatExperienceTermsFull(exp, t)}
                people={exp?.max_guests}
                price={exp?.min_price}
                experienceId={exp?.uuid}
                showFavoriteButton={true}
                favorite={exp?.is_favorite}
                mode="guideProfile"
                guuid={guuid}
                pricingType={exp?.pricing_type}
                includedGuests={exp?.included_guests ?? exp?.guests_included_in_flat_rate}
                pricePerAdult={exp?.price_per_person}
                pricePerChild={exp?.price_per_child}
                pricePerInfant={exp?.price_per_infant}
                tripPrices={exp?.trip_prices}
                durationType={exp?.duration_type}
                durationValue={exp?.duration_value}
              />
            </div>
          )
        })}
      </div>

      {shouldShowWaypoint && (
        <Waypoint
          onEnter={onLoadMore}
          scrollableAncestor={scrollableAncestor}
          bottomOffset="-200px"
        />
      )}

      {loading && (
        <div className={styles.loadingContainer}>
          <Spin size="large" />
        </div>
      )}
    </>
  )
}

ExperienceGrid.propTypes = {
  experiences: PropTypes.arrayOf(PropTypes.object).isRequired,
  guuid: PropTypes.string,
  loading: PropTypes.bool,
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func.isRequired,
  metadata: PropTypes.object,
  scrollableAncestor: PropTypes.object
}

ExperienceGrid.defaultProps = {
  loading: false,
  hasMore: true,
  guuid: null,
  metadata: null,
  scrollableAncestor: null
}

export default ExperienceGrid
